import React from 'react';

import { CommonInputProps, CustomTagProps } from '../../types';
import { RCFormGroupAlertText, RCTag } from '../../';

/** props that form elements typically pass through */
export interface CheckableLabelProps extends Omit<CommonInputProps, 'tag' | 'name'> {
  /** Additional line of text below main label; sentence-case without ending punctuation. Not rendered if `variant` is set to `switch`. */
  sublabel?: React.ReactNode;

  htmlFor?: string;
  customTag?: CustomTagProps;
}

export function RCCheckableLabel({
  label,
  htmlFor = undefined,
  errorText = undefined,
  sublabel = undefined,
  customTag = undefined,
}: CheckableLabelProps) {
  return (
    <label
      className="rc-checkable-label"
      htmlFor={htmlFor}
    >
      {label}
      {customTag && (
        <>
          <span className="mr-1" />
          <RCTag
            variant={customTag.variant || 'highlight'}
          >
            {customTag.label}
          </RCTag>
        </>
      )}
      {sublabel && (
        <span className="rc-checkable-label__sublabel">
          {sublabel}
        </span>
      )}
      {errorText && (
        <RCFormGroupAlertText errorText={errorText} />
      )}
    </label>
  );
}
